import { format, parseISO } from "date-fns";

/** Customer-facing booking push body (mirrors business inbox format). */
export function formatExploreBookingBody(input: {
  businessName: string;
  serviceLabel: string;
  startDatetime: Date | string;
}): string {
  const when =
    input.startDatetime instanceof Date
      ? format(input.startDatetime, "EEE, MMM d · h:mm a")
      : format(parseISO(String(input.startDatetime)), "EEE, MMM d · h:mm a");

  const business = input.businessName.trim() || "the salon";
  const service = input.serviceLabel.trim() || "a service";

  return `Your ${service} at ${business} • ${when}`;
}
